import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.centerswitcher');
import { OnInit, Input, Output, EventEmitter, HostListener, ElementRef, ViewChild } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

const CENTERS: { [key: string]: string } = {
    solution: 'AI 솔루션센터',
    research: 'AI 연구센터',
};

@Component({
    selector: 'wiz-component-centerswitcher',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.centerswitcher/view.scss */
:host {
  display: block;
}

@keyframes centerDropdownIn {
  from {
    opacity: 0;
    transform: translateY(-0.5rem);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes centerDropdownOut {
  from {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
  to {
    opacity: 0;
    transform: translateY(-0.25rem) scale(0.98);
  }
}
.center-dropdown {
  animation: centerDropdownIn 0.15s ease-out;
}

.center-dropdown-closing {
  animation: centerDropdownOut 0.25s ease-out forwards;
}

@media (max-width: 768px) {
  .center-switcher {
    transform: scale(0.85);
    transform-origin: top left;
  }
  .center-dropdown {
    width: 10rem !important;
  }
}`],
})
export class ComponentCenterswitcherComponent implements OnInit {
    @Input() currentRoom: string = 'solution';
    @Input() isMobile: boolean = false;
    @Output() closeOtherDropdowns = new EventEmitter<void>();
    @Output() centerSwitchRequest = new EventEmitter<string>();
    @ViewChild('dropdownBox') dropdownBoxRef: any;

    public showDropdown: boolean = false;
    public isClosing: boolean = false;

    constructor(@Inject( Service) public service: Service,@Inject( ElementRef)  private elementRef: ElementRef) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.render();
    }

    @HostListener('document:mousedown', ['$event'])
    onDocumentMouseDown(event: MouseEvent) {
        if (!this.showDropdown || this.isClosing) return;
        const dropdownEl = this.dropdownBoxRef?.nativeElement;
        if (dropdownEl && dropdownEl.contains(event.target)) return;
        this.closeDropdown();
    }

    public get currentCenterName(): string {
        return CENTERS[this.currentRoom] || CENTERS['solution'];
    }

    public get centers(): Array<{ key: string, name: string }> {
        return Object.keys(CENTERS).map(key => ({ key, name: CENTERS[key] }));
    }

    public async toggleDropdown() {
        if (this.showDropdown) {
            this.closeDropdown();
        } else {
            this.closeOtherDropdowns.emit();
            this.showDropdown = true;
            await this.service.render();
        }
    }

    public async onCenterClick(key: string) {
        if (key === this.currentRoom) {
            this.showDropdown = false;
            this.isClosing = false;
            await this.service.render();
            return;
        }
        this.showDropdown = false;
        this.isClosing = false;
        this.centerSwitchRequest.emit(key);
        await this.service.render();
    }

    public async closeDropdown() {
        if (!this.showDropdown || this.isClosing) return;
        this.isClosing = true;
        await this.service.render();
        setTimeout(async () => {
            this.showDropdown = false;
            this.isClosing = false;
            await this.service.render();
        }, 250);
    }

    public async forceClose() {
        this.showDropdown = false;
        this.isClosing = false;
        await this.service.render();
    }
}

export default ComponentCenterswitcherComponent;